export const ROI_THESIS = {
  badge: "ROI CALCULATOR",
  headline: "Calculate Your Unutilized Margin",
  subhead:
    "Adjust your client book and markup to see how much recurring margin you can activate today.",
};

export const SLIDER_FIELDS = [
  {
    id: "clients",
    label: "Active Clients",
    testId: "slider-clients",
  },
  {
    id: "markup",
    label: "Monthly Markup per Client",
    testId: "slider-markup",
  },
  {
    id: "churn",
    label: "Estimated Churn Reduction",
    testId: "slider-churn",
  },
];

export const OUTPUT_METRICS = [
  {
    id: "annual",
    label: "Annual Net Profit",
    suffix: "/yr",
  },
  {
    id: "ltv",
    label: "Client LTV Increase",
    suffix: "",
  },
];
